module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "cont",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "fmh1"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_c('i', [_vm._v("Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "int"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter001"
    }
  }, [_vm._v("CHAPTER 1: "), _c('i', [_vm._v("What You Need to Get Started")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 2: "), _c('i', [_vm._v("Brush Pen Ergonomics")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 3: "), _c('i', [_vm._v("Brush Pen Warm-Up")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 4: "), _c('i', [_vm._v("Basic Strokes")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 5: "), _c('i', [_vm._v("Connecting Basic Strokes")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6: "), _c('i', [_vm._v("Lowercase Alphabet")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 7: "), _c('i', [_vm._v("Uppercase Alphabet")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 8: "), _c('i', [_vm._v("Connecting Letters")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 9: "), _c('i', [_vm._v("Words")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 10: "), _c('i', [_vm._v("Numbers and Symbols")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 11: "), _c('i', [_vm._v("Developing Style")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "app"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Appendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ata"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE AUTHOR")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0156f4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Contents.vue
// module id = 66
// module chunks = 0